// Mock drone listings data
export const droneListings = [
  {
    id: 1,
    title: 'Heavy-Lift UAV Rental in London',
    location: 'London, UK',
    country: 'united-kingdom',
    category: 'Heavy-Lift',
    featured: true,
    image: 'https://images.unsplash.com/photo-1473968512647-3e447244af8f?w=800&q=80',
    description: 'Professional heavy-lift drone capable of carrying up to 25kg payload. Ideal for construction site deliveries and aerial logistics.',
    specs: ['25kg Payload', '45 min Flight Time', '10km Range'],
    price: '£2,500/week',
    vendor: 'SkyLift Solutions Ltd',
  },
  {
    id: 2,
    title: 'Thermal Inspection Drone - DJI M300 RTK',
    location: 'Manchester, UK',
    country: 'united-kingdom',
    category: 'Thermal Inspection',
    featured: true,
    image: 'https://images.unsplash.com/photo-1508614999368-9260051292e5?w=800&q=80',
    description: 'Enterprise-grade thermal inspection platform with radiometric capabilities for infrastructure and building surveys.',
    specs: ['Dual Thermal Camera', '55 min Flight Time', '15km Range'],
    price: '£18,500',
    vendor: 'Thermal UAV Services',
  },
  {
    id: 3,
    title: 'Photogrammetry Mapping Drone Package',
    location: 'Berlin, Germany',
    country: 'germany',
    category: 'Photogrammetry',
    featured: false,
    image: 'https://images.unsplash.com/photo-1523133045649-1a132addedd4?w=800&q=80',
    description: 'Complete photogrammetry solution with RTK GPS and high-resolution 61MP camera for precision mapping.',
    specs: ['61MP Camera', '42 min Flight Time', 'RTK GPS'],
    price: '€22,000',
    vendor: 'AeroMap GmbH',
  },
  {
    id: 4,
    title: 'Agricultural Spraying Drone - 20L Capacity',
    location: 'California, USA',
    country: 'united-states',
    category: 'Agricultural',
    featured: true,
    image: 'https://images.pexels.com/photos/3634730/pexels-photo-3634730.jpeg?w=800&q=80',
    description: 'Autonomous agricultural drone with 20L tank capacity for crop spraying and seeding operations.',
    specs: ['20L Tank', '20 min Flight Time', '8 Nozzles'],
    price: '$35,000',
    vendor: 'AgriDrone Systems Inc',
  },
  {
    id: 5,
    title: 'Long-Range Surveillance UAV',
    location: 'Sydney, Australia',
    country: 'australia',
    category: 'Surveillance',
    featured: false,
    image: 'https://images.unsplash.com/photo-1721969661090-22850761bb70?w=800&q=80',
    description: 'Military-grade surveillance platform with 8-hour endurance and encrypted communications.',
    specs: ['8hr Endurance', '150km Range', 'Encrypted Comms'],
    price: 'Contact for Quote',
    vendor: 'SecureAir Defence',
  },
  {
    id: 6,
    title: 'Last-Mile Delivery Drone',
    location: 'Singapore',
    country: 'singapore',
    category: 'Delivery',
    featured: false,
    image: 'https://images.unsplash.com/photo-1639847648040-b1af1ce3cecf?w=800&q=80',
    description: 'Urban delivery drone designed for e-commerce logistics with automated package drop system.',
    specs: ['5kg Payload', '30 min Flight', 'Autonomous'],
    price: '$45,000',
    vendor: 'DeliverAir Pte Ltd',
  },
  {
    id: 7,
    title: 'Professional FPV Racing Drone Kit',
    location: 'Tokyo, Japan',
    country: 'japan',
    category: 'Racing',
    featured: false,
    image: 'https://images.unsplash.com/photo-1456615913800-c33540eac399?w=800&q=80',
    description: 'Competition-ready FPV racing drone with carbon fiber frame and high-performance motors.',
    specs: ['180km/h Top Speed', '7 min Flight', 'HD FPV'],
    price: '¥180,000',
    vendor: 'RaceDrone Japan',
  },
  {
    id: 8,
    title: 'Cinema-Grade Aerial Platform - RED Komodo Ready',
    location: 'Los Angeles, USA',
    country: 'united-states',
    category: 'Cinematography',
    featured: true,
    image: 'https://images.unsplash.com/photo-1753781467329-416d05e7e477?w=800&q=80',
    description: 'Heavy-lift cinema drone capable of carrying RED Komodo or Alexa Mini. Perfect for film productions.',
    specs: ['8kg Payload', '25 min Flight', '6-Axis Gimbal'],
    price: '$8,500/week',
    vendor: 'Hollywood Aerial Films',
  },
  {
    id: 9,
    title: 'Search & Rescue Drone with Spotlight',
    location: 'Toronto, Canada',
    country: 'canada',
    category: 'Search & Rescue',
    featured: false,
    image: 'https://images.pexels.com/photos/22500569/pexels-photo-22500569.png?w=800&q=80',
    description: 'Emergency response UAV with thermal imaging, spotlight, and loudspeaker for SAR operations.',
    specs: ['Thermal + RGB', '45 min Flight', 'IP55 Rating'],
    price: 'CAD $28,000',
    vendor: 'RescueAir Canada',
  },
  {
    id: 10,
    title: 'LiDAR Mapping Drone - Survey Grade',
    location: 'Dubai, UAE',
    country: 'uae',
    category: 'Mapping',
    featured: true,
    image: 'https://images.pexels.com/photos/27488428/pexels-photo-27488428.jpeg?w=800&q=80',
    description: 'Professional LiDAR mapping system achieving survey-grade accuracy for construction and mining.',
    specs: ['2cm Accuracy', '35 min Flight', '300pts/sqm'],
    price: 'Request Quote',
    vendor: 'GeoScan Middle East',
  },
];

export const countries = [
  { name: 'United States', slug: 'united-states', flag: '🇺🇸', count: 850 },
  { name: 'United Kingdom', slug: 'united-kingdom', flag: '🇬🇧', count: 320 },
  { name: 'Germany', slug: 'germany', flag: '🇩🇪', count: 280 },
  { name: 'France', slug: 'france', flag: '🇫🇷', count: 245 },
  { name: 'Japan', slug: 'japan', flag: '🇯🇵', count: 210 },
  { name: 'China', slug: 'china', flag: '🇨🇳', count: 195 },
  { name: 'Canada', slug: 'canada', flag: '🇨🇦', count: 180 },
  { name: 'Australia', slug: 'australia', flag: '🇦🇺', count: 165 },
  { name: 'Brazil', slug: 'brazil', flag: '🇧🇷', count: 145 },
  { name: 'India', slug: 'india', flag: '🇮🇳', count: 130 },
  { name: 'Singapore', slug: 'singapore', flag: '🇸🇬', count: 95 },
  { name: 'UAE', slug: 'uae', flag: '🇦🇪', count: 85 },
];